import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import * as PIXI from "pixi.js";
import { SlingoStyle } from "../style/SlingoStyle";
/**
 * AbstractTicketProperties.ts
 */
export class AbstractTicketProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            (this.backgroundProperties ? this.backgroundProperties.equals(other.backgroundProperties) : this.backgroundProperties === other.backgroundProperties) &&
            (this.backgroundAnimationProperties ? this.backgroundAnimationProperties.equals(other.backgroundAnimationProperties) : this.backgroundAnimationProperties === other.backgroundAnimationProperties) &&
            this.symbolPanelProperties.equals(other.symbolPanelProperties) &&
            (this.symbolWinInterval === other.symbolWinInterval) &&
            (this.patternWinInterval === other.patternWinInterval) &&
            (this.slingoInitialDelay === other.slingoInitialDelay) &&
            this.randomPatterns.every((val, index) => val === other.randomPatterns[index]) &&
            (this.randomPatternDuration === other.randomPatternDuration) &&
            this.bigWinPattern.every((val, index) => val === other.bigWinPattern[index]) &&
            (this.bigWinPatternDuration === other.bigWinPatternDuration) &&
            (this.bigWinFlashDuration === other.bigWinFlashDuration) &&
            this.fullHousePattern.every((val, index) => val === other.fullHousePattern[index]) &&
            (this.fullHousePatternDuration === other.fullHousePatternDuration) &&
            (this.fullHouseFlashDuration === other.fullHouseFlashDuration) &&
            (this.animationDelay === other.animationDelay);
    }
    setDefaultValues() {
        this.createPatterns();
        this.backgroundProperties = new SpriteProperties(SlingoStyle.GRID_BORDER, SlingoStyle.MODULE, new PIXI.Point(0, 0), new PIXI.Point(1, 1));
        this.symbolWinInterval = 100;
        this.patternWinInterval = 500;
        this.slingoInitialDelay = 0;
        this.randomPatternDuration = 1600;
        this.bigWinPatternDuration = 2000;
        this.bigWinFlashDuration = 250;
        this.fullHousePatternDuration = 4000;
        this.fullHouseFlashDuration = 250;
        this.animationDelay = 750;
    }
    createPatterns() {
        this.randomPatterns = [];
        this.randomPatterns.push(this.createPattern0());
        this.randomPatterns.push(this.createPattern1());
        this.bigWinPattern = this.createBigWinPattern();
        this.fullHousePattern = this.createFullHousePattern();
    }
    createPattern0() {
        return [
            [new PIXI.Point(0, 0)],
            [new PIXI.Point(1, 0), new PIXI.Point(0, 1)],
            [new PIXI.Point(2, 0), new PIXI.Point(1, 1), new PIXI.Point(0, 2)],
            [new PIXI.Point(3, 0), new PIXI.Point(2, 1), new PIXI.Point(1, 2), new PIXI.Point(0, 3)],
            [new PIXI.Point(4, 0), new PIXI.Point(3, 1), new PIXI.Point(2, 2), new PIXI.Point(1, 3), new PIXI.Point(0, 4)],
            [new PIXI.Point(4, 1), new PIXI.Point(3, 2), new PIXI.Point(2, 3), new PIXI.Point(1, 4)],
            [new PIXI.Point(4, 2), new PIXI.Point(3, 3), new PIXI.Point(2, 4)],
            [new PIXI.Point(4, 3), new PIXI.Point(3, 4)],
            [new PIXI.Point(4, 4)]
        ];
    }
    createPattern1() {
        return [
            [new PIXI.Point(0, 0)],
            [new PIXI.Point(1, 0)],
            [new PIXI.Point(2, 0)],
            [new PIXI.Point(3, 0)],
            [new PIXI.Point(4, 0)],
            [new PIXI.Point(4, 1)],
            [new PIXI.Point(4, 2)],
            [new PIXI.Point(4, 3)],
            [new PIXI.Point(4, 4)],
            [new PIXI.Point(3, 4)],
            [new PIXI.Point(2, 4)],
            [new PIXI.Point(1, 4)],
            [new PIXI.Point(0, 4)],
            [new PIXI.Point(0, 3)],
            [new PIXI.Point(0, 2)],
            [new PIXI.Point(0, 1)],
            [new PIXI.Point(1, 1)],
            [new PIXI.Point(2, 1)],
            [new PIXI.Point(3, 1)],
            [new PIXI.Point(3, 2)],
            [new PIXI.Point(3, 3)],
            [new PIXI.Point(2, 3)],
            [new PIXI.Point(1, 3)],
            [new PIXI.Point(1, 2)],
            [new PIXI.Point(1, 1)],
            [new PIXI.Point(2, 1)],
            [new PIXI.Point(2, 2)],
        ];
    }
    createBigWinPattern() {
        return [
            [new PIXI.Point(0, 0)],
            [new PIXI.Point(1, 0), new PIXI.Point(0, 1)],
            [new PIXI.Point(2, 0), new PIXI.Point(1, 1), new PIXI.Point(0, 2)],
            [new PIXI.Point(3, 0), new PIXI.Point(2, 1), new PIXI.Point(1, 2), new PIXI.Point(0, 3)],
            [new PIXI.Point(4, 0), new PIXI.Point(3, 1), new PIXI.Point(2, 2), new PIXI.Point(1, 3), new PIXI.Point(0, 4)],
            [new PIXI.Point(4, 1), new PIXI.Point(3, 2), new PIXI.Point(2, 3), new PIXI.Point(1, 4)],
            [new PIXI.Point(4, 2), new PIXI.Point(3, 3), new PIXI.Point(2, 4)],
            [new PIXI.Point(4, 3), new PIXI.Point(3, 4)],
            [new PIXI.Point(4, 4)],
            [new PIXI.Point(4, 3), new PIXI.Point(3, 4)],
            [new PIXI.Point(4, 2), new PIXI.Point(3, 3), new PIXI.Point(2, 4)],
            [new PIXI.Point(4, 1), new PIXI.Point(3, 2), new PIXI.Point(2, 3), new PIXI.Point(1, 4)],
            [new PIXI.Point(4, 0), new PIXI.Point(3, 1), new PIXI.Point(2, 2), new PIXI.Point(1, 3), new PIXI.Point(0, 4)],
            [new PIXI.Point(3, 0), new PIXI.Point(2, 1), new PIXI.Point(1, 2), new PIXI.Point(0, 3)],
            [new PIXI.Point(2, 0), new PIXI.Point(1, 1), new PIXI.Point(0, 2)],
            [new PIXI.Point(1, 0), new PIXI.Point(0, 1)],
            [new PIXI.Point(0, 0)],
        ];
    }
    createFullHousePattern() {
        return [
            [new PIXI.Point(0, 0)],
            [new PIXI.Point(1, 0), new PIXI.Point(0, 1)],
            [new PIXI.Point(2, 0), new PIXI.Point(1, 1), new PIXI.Point(0, 2)],
            [new PIXI.Point(3, 0), new PIXI.Point(2, 1), new PIXI.Point(1, 2), new PIXI.Point(0, 3)],
            [new PIXI.Point(4, 0), new PIXI.Point(3, 1), new PIXI.Point(2, 2), new PIXI.Point(1, 3), new PIXI.Point(0, 4)],
            [new PIXI.Point(4, 1), new PIXI.Point(3, 2), new PIXI.Point(2, 3), new PIXI.Point(1, 4)],
            [new PIXI.Point(4, 2), new PIXI.Point(3, 3), new PIXI.Point(2, 4)],
            [new PIXI.Point(4, 3), new PIXI.Point(3, 4)],
            [new PIXI.Point(4, 4)],
            [new PIXI.Point(4, 3), new PIXI.Point(3, 4)],
            [new PIXI.Point(4, 2), new PIXI.Point(3, 3), new PIXI.Point(2, 4)],
            [new PIXI.Point(4, 1), new PIXI.Point(3, 2), new PIXI.Point(2, 3), new PIXI.Point(1, 4)],
            [new PIXI.Point(4, 0), new PIXI.Point(3, 1), new PIXI.Point(2, 2), new PIXI.Point(1, 3), new PIXI.Point(0, 4)],
            [new PIXI.Point(3, 0), new PIXI.Point(2, 1), new PIXI.Point(1, 2), new PIXI.Point(0, 3)],
            [new PIXI.Point(2, 0), new PIXI.Point(1, 1), new PIXI.Point(0, 2)],
            [new PIXI.Point(1, 0), new PIXI.Point(0, 1)],
            [new PIXI.Point(0, 0)],
            [new PIXI.Point(1, 0), new PIXI.Point(0, 1)],
            [new PIXI.Point(2, 0), new PIXI.Point(1, 1), new PIXI.Point(0, 2)],
            [new PIXI.Point(3, 0), new PIXI.Point(2, 1), new PIXI.Point(1, 2), new PIXI.Point(0, 3)],
            [new PIXI.Point(4, 0), new PIXI.Point(3, 1), new PIXI.Point(2, 2), new PIXI.Point(1, 3), new PIXI.Point(0, 4)],
            [new PIXI.Point(4, 1), new PIXI.Point(3, 2), new PIXI.Point(2, 3), new PIXI.Point(1, 4)],
            [new PIXI.Point(4, 2), new PIXI.Point(3, 3), new PIXI.Point(2, 4)],
            [new PIXI.Point(4, 3), new PIXI.Point(3, 4)],
            [new PIXI.Point(4, 4)],
            [new PIXI.Point(4, 3), new PIXI.Point(3, 4)],
            [new PIXI.Point(4, 2), new PIXI.Point(3, 3), new PIXI.Point(2, 4)],
            [new PIXI.Point(4, 1), new PIXI.Point(3, 2), new PIXI.Point(2, 3), new PIXI.Point(1, 4)],
            [new PIXI.Point(4, 0), new PIXI.Point(3, 1), new PIXI.Point(2, 2), new PIXI.Point(1, 3), new PIXI.Point(0, 4)],
            [new PIXI.Point(3, 0), new PIXI.Point(2, 1), new PIXI.Point(1, 2), new PIXI.Point(0, 3)],
            [new PIXI.Point(2, 0), new PIXI.Point(1, 1), new PIXI.Point(0, 2)],
            [new PIXI.Point(1, 0), new PIXI.Point(0, 1)],
            [new PIXI.Point(0, 0)],
        ];
    }
}
//# sourceMappingURL=AbstractTicketProperties.js.map